document.addEventListener("DOMContentLoaded", function() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy-video"));

    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }

            video.target.load();
            video.target.classList.replace("lazy-video", "lazy-video-loaded");
            video.target.addEventListener("play", () => {
              var playBtn = video.target.parentNode.querySelector('.js-toggle-play[data-toggle="play"]'),
                pauseBtn = video.target.parentNode.querySelector('.js-toggle-play[data-toggle="pause"]');
                if(playBtn) {
                  playBtn.style.display = 'none';
                }
                if(pauseBtn) {
                  pauseBtn.style.display = '';
                }
            });
            video.target.addEventListener("pause", () => {
              var playBtn = video.target.parentNode.querySelector('.js-toggle-play[data-toggle="play"]'),
                pauseBtn = video.target.parentNode.querySelector('.js-toggle-play[data-toggle="pause"]');
                if(playBtn) {
                  playBtn.style.display = '';
                }
                if(pauseBtn) {
                  pauseBtn.style.display = 'none';
                }
            });
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  });
